import React from "react";
import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import ServicePage from "../components/Service";

const Service = () => {
  return (
    <section className='models-section'>
      <HeroPages name='Our Services' />
      <div className='container'>
        <ServicePage />
      </div>
      <Footer />
    </section>
  );
};

export default Service;
